// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn.mini[data-v-15811315]{width:30px;height:30px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
